import {useMemo} from 'react';

import {PanelBankConfigWithRefs} from '../../../components/PanelBank/types';
import {usePart} from '../hooks';
import {usePanelBankSectionConfigs} from '../panelBankSectionConfig/hooks';
import * as PanelBankConfigTypes from './types';

export function usePanelBankConfig(
  ref: PanelBankConfigTypes.Ref
): PanelBankConfigWithRefs {
  const part = usePart(ref);
  const sections = usePanelBankSectionConfigs(part.sectionRefs);
  return useMemo(() => ({...part, sections, ref}), [ref, part, sections]);
}
